import apiClient from "./apiClient";
import { AuthResponse, RefreshResponse, RegisterApiType, SigninApiType } from "../../types/types";
import { API_ENDPOINTS } from "../../utils/config/constants";

export type TelegramAuthPayload = {
    id: number;
    first_name?: string;
    last_name?: string;
    username?: string;
    photo_url?: string;
    auth_date: number;
    hash: string;
    deviceModel?: string | null;
    firebaseId?: string | null;
};

export const SigninApi = {
    login: async ({username, password, deviceModel, firebaseId}: SigninApiType) => {
        const response = await apiClient.post<AuthResponse>(API_ENDPOINTS.LOGIN, {
            username,
            password,
            deviceModel,
            firebaseId,
        });
        return response.data;
    },
    verifyLoginCode: async (challengeId: string, code: string) => {
        const response = await apiClient.post<AuthResponse>(API_ENDPOINTS.LOGIN_VERIFY_CODE, { challengeId, code });
        return response.data;
    },
    requestPasswordReset: async (email: string) => {
        const response = await apiClient.post<{ challengeId: string }>(API_ENDPOINTS.PASSWORD_RESET_REQUEST, { email });
        return response.data;
    },
    confirmPasswordReset: async (challengeId: string, code: string, newPassword: string) => {
        await apiClient.post(API_ENDPOINTS.PASSWORD_RESET_CONFIRM, { challengeId, code, newPassword });
    },
    register: async ({username, mail, password, personalDataConsent, crossBorderConsent}: RegisterApiType) => {
        await apiClient.post(API_ENDPOINTS.REGISTER, {
            username: username?.trim() || null,
            mail,
            password,
            personalDataConsent,
            crossBorderConsent,
        });
    },
    telegram: async (payload: TelegramAuthPayload) => {
        const response = await apiClient.post<AuthResponse>(API_ENDPOINTS.TELEGRAM, payload);
        return response.data;
    },
    refresh: async () => {
        const response = await apiClient.post<RefreshResponse>(API_ENDPOINTS.REFRESH);
        return response.data;
    },
}
